import LinksTable from './LinksTableContainer';

export default LinksTable;
